import React, { useEffect, useState } from 'react'
import AddressUpdateQuestionView from './components/AddressUpdateQuestionView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const AddressUpdateQuestion = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('address-update-question', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <AddressUpdateQuestionView setIsError={setIsError} />
}

export default withTranslation('common')(AddressUpdateQuestion)
